module.exports = __webpack_public_path__ + "img/04.0f34e938.svg";